import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import theme from "./theme/theme";
import { useCommonFetchInit } from "./api/commonFetch";
import AppContent from "./components/AppContent/AppContent";
import { SnackbarProvider } from "./components/SnackBar/SnackbarContext";
function App() {
  useCommonFetchInit()
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
       <SnackbarProvider>
        <AppContent />
        </SnackbarProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
